import { JSX } from 'react'

import { IconProps } from '../../icon'

const Students: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M37.7137 30.7565V18.5246L39.2684 17.9188C39.4816 17.8345 39.6646 17.6881 39.7935 17.4985C39.9224 17.3089 39.9914 17.0849 39.9914 16.8556C39.9914 16.6263 39.9224 16.4024 39.7935 16.2128C39.6646 16.0232 39.4816 15.8767 39.2684 15.7925L24.4072 10.0766C24.1424 9.97445 23.849 9.97445 23.5841 10.0766L8.72298 15.7925C8.50976 15.8767 8.3268 16.0232 8.19787 16.2128C8.06894 16.4024 8 16.6263 8 16.8556C8 17.0849 8.06894 17.3089 8.19787 17.4985C8.3268 17.6881 8.50976 17.8345 8.72298 17.9188L14.8504 20.2851L13.7072 26.9612C13.6642 27.2232 13.7137 27.4919 13.8471 27.7213C13.9806 27.9508 14.1898 28.1266 14.4388 28.2187L23.5841 31.6482C23.843 31.7397 24.1255 31.7397 24.3844 31.6482L33.5297 28.2187C33.7787 28.1266 33.9879 27.9508 34.1213 27.7213C34.2548 27.4919 34.3043 27.2232 34.2613 26.9612L33.2096 20.2851L35.4273 19.4049V30.7565C34.7629 30.9753 34.1843 31.3979 33.7739 31.9643C33.3634 32.5307 33.142 33.2121 33.141 33.9117V37.4326C33.141 37.7358 33.2614 38.0266 33.4758 38.2409C33.6902 38.4553 33.981 38.5758 34.2842 38.5758H38.8568C39.16 38.5758 39.4508 38.4553 39.6652 38.2409C39.8796 38.0266 40 37.7358 40 37.4326V33.9117C39.999 33.2121 39.7776 32.5307 39.3671 31.9643C38.9567 31.3979 38.3781 30.9753 37.7137 30.7565ZM23.9957 12.363L35.6674 16.8556L23.9957 21.3483L12.324 16.8556L23.9957 12.363ZM31.8721 26.4011L23.9957 29.3504L16.1307 26.4011L17.0109 21.1082L23.5841 23.6346C23.849 23.7368 24.1424 23.7368 24.4072 23.6346L31.0261 21.0853L31.8721 26.4011ZM37.7137 36.2894H35.4273V33.9117C35.4273 33.6327 35.5381 33.3652 35.7354 33.168C35.9326 32.9707 36.2001 32.8599 36.479 32.8599H36.662C36.8001 32.8599 36.9368 32.8871 37.0644 32.94C37.192 32.9928 37.308 33.0703 37.4056 33.168C37.5033 33.2656 37.5808 33.3816 37.6336 33.5092C37.6865 33.6368 37.7137 33.7735 37.7137 33.9117V36.2894Z'
      fill='black'
    />
  </svg>
)

export default Students
